// AuthGate — wraps authenticated routes. Redirects to /auth/login when the
// user is not signed in; renders the protected content when they are.

import { useAuthState } from 'react-firebase-hooks/auth'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { auth } from '../lib/firebase.js'

export function AuthGate({ children }) {
  const [user, loading] = useAuthState(auth)
  const location = useLocation()

  if (loading) {
    return (
      <div
        className="flex min-h-screen items-center justify-center text-[var(--color-schist)]"
        aria-live="polite"
        aria-busy="true"
      >
        Loading…
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/auth/login" replace state={{ from: location.pathname }} />
  }

  return children ?? <Outlet />
}
